class VariantDropdown extends HTMLElement {
  constructor() {
    super();
    this.selectorSize = this.querySelector('.size-selected-js')
  }

  connectedCallback() {
    this.changeListener();
  }

  changeListener() {
    document.addEventListener('variant:change', (e) => {
      const targetDropdown = e.detail.originalEvent?.target.closest('variant-dropdown');
      if (targetDropdown !== this) return;
      
      this.selectedOptionSize(e.detail.originalEvent);
    });

    if (this.selectorSize) {
      this.selectorSize.addEventListener('click', (e) => {
        const parentDropDown = e.target.closest('variant-dropdown');
        if (parentDropDown) {
          parentDropDown.classList.toggle('active');
        }

        const handleOutsideClick = (event) => {
          if (!parentDropDown.contains(event.target) && parentDropDown.classList.contains('active')) {
            parentDropDown.classList.remove('active');
            document.removeEventListener('click', handleOutsideClick);
          }
        };

        setTimeout(() => {
          document.addEventListener('click', handleOutsideClick);
        }, 0);
      });

    }
  }

  selectedOptionSize(event) {
    if (!event) return;
    const parentSelector = event.target.closest('.parent-selector');
    const parentOption = event.target.closest('.size-option-js');

    if (parentOption) {
      const labelOption = parentOption.querySelector('label');
      const labelSelector = parentSelector.querySelector('.label-selected-js');


      if (labelSelector && labelOption) labelSelector.innerHTML = labelOption.innerHTML;
      if (labelOption && this.selectorSize) this.selectorSize.innerHTML = labelOption.innerHTML;
      

      this.classList.toggle('active');
    }
    
  }
}

customElements.define('variant-dropdown', VariantDropdown);

const container = document.querySelector('.complete-products__items')

if(container){

  const config = { attributes: true, childList: true, subtree: true };
  const callback = (mutationList, observer) => {
    container.scrollTo({
      top: 1000,
      left: container.scrollLeft,
      behavior: 'smooth'
    })
  }
  const obs = new MutationObserver(callback);
  obs.observe(container, config);
}

